/** @jsxImportSource theme-ui */
import {
  AppBar,
  Box,
  Button,
  Grid,
  Tab,
  Tabs,
  Toolbar,
  Typography,
} from "@material-ui/core";
import useScrollPosition from "@react-hook/window-scroll";
import { NAVBAR_HEIGHT } from "app-constants";
import { ReactComponent as LogoutIcon } from "assets/icons/icon-logout.svg";
import { ADMIN_ROOT } from "components/router/routes";
import useRouter from "hooks/use-router";
import React from "react";
import { Link } from "react-router-dom";

const routes = [
  {
    label: "Dashboard",
    path: "/",
  },
  {
    label: "Opportunities",
    path: "/opportunities",
  },
  {
    label: "Administration",
    path: ADMIN_ROOT,
    admin: true,
  },
];

export type NavBarProps = {
  hasNav?: boolean;
  handleSignout?: () => void;
  theme?: "dark" | "light";
};

const NavBar: React.FC<NavBarProps> = ({ hasNav, theme, handleSignout }) => {
  const { pathname, push } = useRouter();

  const isAdmin = false; // replace by user?.admin
  const handleChange = (
    event: React.ChangeEvent<unknown>,
    newValue: string
  ) => {
    push(newValue);
  };

  const scrollY = useScrollPosition(60);
  const strippedPathname = `/${pathname.split("/")[1]}`;
  const hasBackground = theme === "dark" || scrollY > 0;
  return (
    <AppBar
      color={hasBackground ? "primary" : "transparent"}
      elevation={0}
      sx={{
        transition: "background-color ease .3s",
      }}
    >
      <Toolbar
        variant="dense"
        sx={{
          minHeight: NAVBAR_HEIGHT,
        }}
      >
        <Grid container alignItems="center" justify="space-between">
          <Grid
            container
            item
            direction="row"
            alignItems="center"
            sx={{ flex: 1 }}
          >
            <Grid item xs={6} sm={4} md={2}>
              <Link
                to={{
                  pathname: "/",
                }}
              >
                <Box>
                  <img src="/assets/logotype.svg" alt="logo" />
                </Box>
              </Link>
            </Grid>
            {hasNav && (
              <Grid item>
                <Tabs
                  value={strippedPathname}
                  onChange={handleChange}
                  aria-label="nav tabs"
                  TabIndicatorProps={{
                    style: {
                      height: 6,
                    },
                  }}
                >
                  {routes
                    .filter((route) => isAdmin || !route.admin)
                    .map(({ label, path }) => (
                      <Tab
                        key={label}
                        value={path}
                        component={Link}
                        to={path}
                        label={<Typography variant="body2">{label}</Typography>}
                        sx={{
                          minHeight: NAVBAR_HEIGHT,
                        }}
                      />
                    ))}
                </Tabs>
              </Grid>
            )}
          </Grid>
          {handleSignout && (
            <Grid item>
              <Button
                onClick={handleSignout}
                sx={{
                  fontSize: 12,
                  color: "white",
                  lineHeight: "12px",
                }}
                endIcon={<LogoutIcon />}
              >
                Logout
              </Button>
            </Grid>
          )}
        </Grid>
      </Toolbar>
    </AppBar>
  );
};
export default NavBar;
